export default "__VITE_ASSET__a90d5623__"